import { render, staticRenderFns } from "./FirstStrategy.vue?vue&type=template&id=549b216f&scoped=true"
import script from "./FirstStrategy.vue?vue&type=script&lang=js"
export * from "./FirstStrategy.vue?vue&type=script&lang=js"
import style0 from "./FirstStrategy.vue?vue&type=style&index=0&id=549b216f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b216f",
  null
  
)

export default component.exports